import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import FinanceReadyToInvoice from "./FinanceReadyToInvoice";
import FinanceDeposits from "./FinanceDeposits";
import FinanceBillsToEnter from "./FinanceBillsToEnter";

export const normalizeFeedRole = (role) => String(
  role && typeof role === "object" ? (role.value || role.role || role.name || "") : (role || "")
).trim().toLowerCase().replace(/[_\s]+/g, "-");

export const getFeedAuthRoles = (authStateOrRole) => {
  if (!authStateOrRole || typeof authStateOrRole !== "object" || Array.isArray(authStateOrRole)) {
    return [normalizeFeedRole(authStateOrRole)].filter(Boolean);
  }
  return [
    authStateOrRole.role,
    ...(Array.isArray(authStateOrRole.roles) ? authStateOrRole.roles : []),
    authStateOrRole.user?.role,
    ...(Array.isArray(authStateOrRole.user?.roles) ? authStateOrRole.user.roles : []),
  ].map(normalizeFeedRole).filter(Boolean);
};

export const shouldShowFinanceFeedHome = (authStateOrRole) =>
  getFeedAuthRoles(authStateOrRole).includes("finance-rep");

export default function FinanceFeedHome({ instanceUniqueId }) {
  return <Box component="section" aria-label="Finance Overview" sx={{ width: "100%", mb: 3 }}>
    <Box sx={{ mb: 1.5 }}><Typography variant="h5" fontWeight={800}>Finance Overview</Typography><Typography color="text.secondary">Keep invoicing work moving.</Typography></Box>
    <Stack spacing={2}>
      <FinanceBillsToEnter instanceUniqueId={instanceUniqueId} />
      <FinanceReadyToInvoice instanceUniqueId={instanceUniqueId} />
      <FinanceDeposits instanceUniqueId={instanceUniqueId} />
    </Stack>
  </Box>;
}
